import { FC } from 'react';

import { useProcessedWorkStore } from '../../studentApp/hooks';
import { bannerStore } from '../../studentApp/stores';

import { Banner } from './banner/banner';
import { BottomBanner } from './banner/bottomBanner';
import { ExamButtons } from './banner/examButtons';
import { WelcomeStrip } from './banner/welcomeStrip';
import { SquaresAndProblem } from './squares/squaresAndProblem';

export const PortraitLayout: FC = () => {
  const { isTesting } = useProcessedWorkStore();
  const [hideWelcomeStrip, setHideWelcomeStrip] = bannerStore(state => [
    state.hideWelcomeStrip,
    state.setHideWelcomeStrip,
  ]);

  const welcomeCloser = (): void => setHideWelcomeStrip(true);

  return (
    <>
      <SquaresAndProblem />
      <div className="sticky-banner">
        {!hideWelcomeStrip && <WelcomeStrip closer={welcomeCloser} />}
        <Banner />
        {isTesting && <ExamButtons />}
      </div>
      <div className="sticky-bottom-banner">
        <BottomBanner />
      </div>
    </>
  );
};
